import React from 'react'
import { graphql } from 'gatsby'
import {
  Layout,
  Wrapper,
  BannerContainer,
  Billboard,
  Row,
  Column,
  BannerWrapper,
  DarkSection,
  Title,
  GreySection,
  H4,
  H3,
  Prompt,
  Paragraph,
  SEO,
} from '../components'
import * as Icons from '../components/icons'
import ArrowImg from '../images/iaas/arrow.png'
import { Arrow } from '../molecules/iaas/atoms'

function Iaas(props) {
  const { data } = props
  return (
    <Layout>
      <SEO
        title='Iaas解决方案，云游戏laas解决方案-斗龙云游戏'
        description='斗龙云游戏Iaas解决方案，拥有5w+GPU资源覆盖全球的200+边缘POP强大的算力资源与智能调度系统助力游戏厂商轻松搭建云游戏生态。'
        keywords='Iaas解决方案,云游戏解决方案,云游戏Iaas解决方案,斗龙云'
      />
      <BannerContainer height={720} mobileHeight={360}>
        <BannerWrapper>
          <h1>
            斗龙云游戏
            <br />
            Iaas解决方案
          </h1>
          <p>
            拥有5w+GPU资源 · 覆盖全球的200+边缘POP
            <br />
            强大的算力资源与智能调度系统
            <br />
            助力游戏厂商轻松搭建云游戏生态
          </p>
        </BannerWrapper>
        <Billboard fluid={data.banner.childImageSharp.fluid} />
      </BannerContainer>
      <DarkSection style={{ paddingBottom: '105px' }}>
        <Wrapper>
          <Title>方案优势</Title>
          <Row spacing={4}>
            <Column xs='6' lg='4'>
              <div>
                <Icons.Iaas1 style={{ fontSize: 60 }} />
                <H3>极致性价比</H3>
                <Paragraph>
                  依托瑞云强大影视离线渲染资源、硬件网络设施，分时复用共享资源，低成本享用高质量云算力服务。
                </Paragraph>
              </div>
            </Column>
            <Column xs='6' lg='4'>
              <div>
                <Icons.Iaas2 style={{ fontSize: 60 }} />
                <H3>海量资源</H3>
                <Paragraph>
                  全球5W+云计算资源，全局智能调度，构建弹性化云服务器资源池，满足更多使用场景。
                </Paragraph>
              </div>
            </Column>
            <Column xs='6' lg='4'>
              <div>
                <Icons.Iaas3 style={{ fontSize: 60 }} />
                <H3>优质网络</H3>
                <Paragraph>
                  全国5大数据中心，主流运营商多线接入，覆盖全国200+POP节点，10Tbps网络带宽资源，快速稳定网络通信能力。
                </Paragraph>
              </div>
            </Column>
            <Column xs='6' lg='4'>
              <div>
                <Icons.Iaas4 style={{ fontSize: 60 }} />
                <H3>安全稳定</H3>
                <Paragraph>
                  凭借10年稳定安全管理体系以及IT系统建设，获得MPAA旗下TPN权威认证，ISO27001认证，提供安全、稳定、合规云服务。
                </Paragraph>
              </div>
            </Column>
            <Column xs='6' lg='4'>
              <div>
                <Icons.Iaas5 style={{ fontSize: 60 }} />
                <H3>多平台硬件提供</H3>
                <Paragraph>
                  全方位支持X86与ARM架构云服务，为手游、端游等多平台游戏提供卓越性能保障，降低游戏业务运营成本，畅享原生态游戏体验。
                </Paragraph>
              </div>
            </Column>
            <Column xs='6' lg='4'>
              <div>
                <Icons.Iaas6 style={{ fontSize: 60 }} />
                <H3>快速接入</H3>
                <Paragraph>
                  4小时接入体验，72小时完成生产上线，提供快速接入、部署、完善API管理与数据接口，让游戏厂商将精力投入游戏运营、开发、设计中。
                </Paragraph>
              </div>
            </Column>
          </Row>
        </Wrapper>
      </DarkSection>
      <GreySection style={{ paddingBottom: '120px' }}>
        <Wrapper>
          <Title>合作模式</Title>
          <Row>
            <Column xs='6' lg='1.5'>
              <Icons.Iaas7 style={{ fontSize: 60, margin: 20 }} />
            </Column>
            <Column xs='6' lg='4.5'>
              <H3>订阅模式</H3>
              <Prompt>
                按包年包月方式计算
                <br />
                客户独享计算资源
              </Prompt>
            </Column>
            <Column xs='6' lg='1.5'>
              <Icons.Iaas8 style={{ fontSize: 60, margin: 20 }} />
            </Column>
            <Column xs='6' lg='4.5'>
              <H3>按需模式</H3>
              <Prompt>
                按实际使用量计算
                <br />
                弹性使用海量计算资源
              </Prompt>
            </Column>
          </Row>
        </Wrapper>
      </GreySection>
      <DarkSection style={{ paddingBottom: '162px' }}>
        <Wrapper>
          <Title>合作流程</Title>
          <Row style={{ textAlign: 'center' }}>
            <Column xs='6' lg='1.5'>
              <Icons.Iaas9 style={{ fontSize: 60 }} />
              <H4>申请合作</H4>
            </Column>
            <Column xs='0' lg='2'>
              <Arrow src={ArrowImg} alt='' />
            </Column>
            <Column xs='6' lg='1.5'>
              <Icons.Iaas10 style={{ fontSize: 60 }} />
              <H4>体验测试</H4>
            </Column>
            <Column xs='0' lg='2'>
              <Arrow src={ArrowImg} alt='' />
            </Column>
            <Column xs='6' lg='1.5'>
              <Icons.Iaas11 style={{ fontSize: 60 }} />
              <H4>节点预定</H4>
            </Column>
            <Column xs='0' lg='2'>
              <Arrow src={ArrowImg} alt='' />
            </Column>
            <Column xs='6' lg='1.5'>
              <Icons.Iaas12 style={{ fontSize: 60 }} />
              <H4>交付上线</H4>
            </Column>
          </Row>
        </Wrapper>
      </DarkSection>
    </Layout>
  )
}

export default Iaas
export const query = graphql`
  query {
    banner: file(relativePath: { regex: "/iaas/banner.png/" }) {
      ...fluidImage
    }
  }
`
